import React, { useEffect, useRef, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import es from '../../assets/flags/espana.png';
import cat from '../../assets/flags/cataluna.png';
import pv from '../../assets/flags/paisVasco.png';
import en from '../../assets/flags/uk.png';
import it from '../../assets/flags/italia.png';
import Cookies from 'js-cookie';


function LanguageSelector({ onChange, grayBackground, availableLanguages, defaultLanguage = false, disabled = false }) {

    const options = [
        { flag: es, label: 'Español', value: 'es' },
        { flag: cat, label: 'Catalá', value: 'ca' },
        { flag: pv, label: 'Euskara', value: 'eu' },
        { flag: en, label: 'English', value: 'en' },
        { flag: it, label: 'Italiano', value: 'it' }
    ]

    let selectedLanguageDefault = defaultLanguage ? defaultLanguage : Cookies.get('myreportin_language');

    const filteredOptions = options.filter(option => availableLanguages.includes(option.value));

    const findSelectedLanguage = (defaultLanguage) => filteredOptions.find(option => option.value === defaultLanguage) || options[0];

    const [isOpen, setIsOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(findSelectedLanguage(selectedLanguageDefault));

    const ref = useRef(null);

    const handleDivClick = (data) => {
        setIsOpen(false);
        if (onChange) {
            onChange(data);
        }
        setSelectedLanguage(data)
    }

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }


    useEffect(() => {
        setSelectedLanguage(findSelectedLanguage(selectedLanguageDefault));
        handleDivClick(findSelectedLanguage(selectedLanguageDefault))
    }, [selectedLanguageDefault]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className='language-container'>
            <div className={`language-selector-container ${disabled && 'language-not-allowed'} ${grayBackground ? 'background-gray' : ''}`} >
                <div className='custom-ellipsis my-auto' ref={ref} onClick={!disabled ? toggleDropdown : null} style={{ zIndex: isOpen ? 100 : 1 }}  >
                    <img src={`${selectedLanguage.flag}`} className={`flag-small ${disabled && 'mx-2'}`} />
                    {!disabled && <FaChevronDown className='flag-dropdown-icon' size={12}></FaChevronDown>}
                </div>
            </div>


            {isOpen && (
                <div className='language-options-container custom-shadow-bold rounded-border-px'>


                    {filteredOptions.map((option, index) => (
                        <div
                            key={index}
                            className={`dropdown-options ${selectedLanguage.label === option.label ? 'dropdown-options-selected' : ''} custom-shadow-bold`}
                            onClick={() => handleDivClick(option)}
                            tabIndex={0}
                            role="button"
                            onKeyDown={(e) => e.key === 'Enter' && handleDivClick(option)}
                        >
                            <img src={`${option.flag}`} className='flag-small' />

                            <span className='ms-2'>{option.label}</span>
                        </div>
                    ))}
                </div>
            )
            }

        </div>
    );
}

export default LanguageSelector;
